import ShiftDetailsPage from "@/app/(app)/(crew)/home/[shift]";
export default ShiftDetailsPage;
